import React from "react"
import { spacefyNumber, areaMeasureNaming } from "../../helpers/littleHelpers"

const ObjectDetails = (props) => {
    let classForLandObjects = "";

    if ( props.houseStatus === null ) {
        classForLandObjects = "landObjectDetails";
    }

    return (
        <>
            <section className={`detailsSection ${classForLandObjects}`}>
                <h2 id="detailsHeading">Характеристики:</h2>
                { props.houseArea ? 
                    <section className="mansionDetails">
                        <h3 className="hidden">Характеристики дома</h3>
                        <dl>
                            <div className="detailsRow">
                                <div className="detailPair">
                                    <dt className="descTitle">площадь дома</dt>
                                    <dd className="descData">{`${spacefyNumber(props.houseArea)} м²`}</dd>
                                </div>
                                <div className="detailPair detailRight">
                                    <dt className="descTitle">состояние дома</dt>
                                    <dd className="descData">{props.houseStatus}</dd>
                                </div>
                            </div>
                            <div className="detailsRow">
                                <div className="detailPair">
                                    <dt className="descTitle">спальни</dt>
                                    <dd className="descData">{props.houseBedrooms}</dd>
                                </div>
                                <div className="detailPair detailRight">
                                    <dt className="descTitle">уровни</dt>
                                    <dd className="descData">{props.houseFloors}</dd>
                                </div>
                            </div>
                            <div className="detailsRow">
                                <div className="detailPair">
                                    <dt className="descTitle">год постройки</dt>
                                    <dd className="descData">{props.houseYear}</dd>
                                </div>
                                <div className="detailPair detailRight">
                                    <dt className="descTitle">бассейн</dt>
                                    <dd className="descData">{props.housePool ? "есть" : "нет"}</dd>
                                </div>
                            </div>
                        </dl>
                    </section>
                : null}
                <section className="landDetails">
                    <h3 className="hidden">Характеристики участка</h3>
                    <dl>
                        <div className="detailsRow">
                            <div className="detailPair">
                                <dt className="descTitle">площадь участка</dt>
                                <dd className="descData">{spacefyNumber(props.siteArea)} {areaMeasureNaming(props.siteArea)}</dd>
                            </div>
                            <div className="detailPair detailRight">
                                <dt className="descTitle">вид права</dt>
                                <dd className="descData">{props.siteProperty}</dd>
                            </div>
                        </div>
                        <div className="detailsRow">
                            <div className="detailPair">
                                <dt className="descTitle">тип участка</dt>
                                <dd className="descData">{props.siteType}</dd>
                            </div>
                            <div className="detailPair detailRight">
                            <dt className="descTitle">состояние участка</dt>
                                <dd className="descData">{props.siteStatus}</dd>
                            </div>
                        </div>
                        <div className="detailsRow">
                            <div className="detailPair">
                                <dt className="descTitle">коммуникации</dt>
                                <dd className="descData">{props.siteResources}</dd>
                            </div>
                            <div className="detailPair detailRight">
                                <dt className="descTitle">ID</dt>
                                <dd className="descData">{props.objectID}</dd>
                            </div>
                        </div>
                    </dl>
                </section>
                <section className="addDetails">
                    <h3 className="descTitle">строения на участке</h3>
                    <p className="descData">{props.siteBuildings}</p>
                </section>
            </section>

        </>
    )
}

export default ObjectDetails;